<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA; min-height: 100vh;">
    <!-- <h2 class="txt-head">
      เพิ่มบริษัทใหม่
    </h2> -->
    <OverlayLoading :loading="loading" />
    <v-row class="mb-2">
      <v-col cols="8">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0" style="font-size: 18px;">
          บริษัท: <span class="header-title" style="font-weight: 400; font-size: 16px;">{{companyName}} </span>
        </span>
        <span class="header-title ml-0" style="font-size: 18px;">
          สายบังคับบัญชา: <span class="header-title" style="font-weight: 400; font-size: 16px;">{{orgChartDetail}} </span>
        </span>
      </v-col>
      <v-col cols="4" class="pt-0 pb-0 d-flex align-center justify-end mt-0">
        <v-btn class="ma-0" outlined color="#3776E9" dark @click="goHistory()">
          <v-icon
            color="#3776E9 darken-2"
            class="pr-0"
            small
          >
            mdi-history
          </v-icon>
          <span class="mx-1">History</span>
        </v-btn>
        <v-btn class="ma-2 mr-5" color="#3776E9" dark @click="goCreateTransfer()">
          <v-icon
            color="#3776E9 darken-2"
            class="pl-0"
            small
          >
            mdi-account-multiple
          </v-icon>
          <span class="mx-1">โอนสิทธิ์</span>
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-card height="auto" min-height="82vh" class="pt-7 pb-7" >
        <div class="text-left ml-8">
          <span class="blue--text text--darken-4 font-weight-bold mr-5 text-title-content">รายละเอียดข้อมูล</span>
        </div>
        <v-row justify="center" align="center">
          <v-col cols="12" class="text-center px-12">
            <v-divider
            ></v-divider>
          </v-col>
        </v-row>
        <v-row>
          <span class="pl-12 pt-4" style="font-weight: bold;">สิทธิ์การลา</span>
          <v-chip
            :color="['approve','acknowledge', 'active'].includes(status)? '#ECF8EA': ['reject', 'expire'].includes(status)? '#FBE5E4': ['pending'].includes(status)? '#FEF5E9': ['cancel', 'inActive'].includes(status)? '#F5F5F5':'#ECF9FF'"
            :text-color="statusList.filter(e => e.status === status)[0].color"
            class="mt-3 ml-2"
          >
            <span>{{statusList.filter(e => e.status === status)[0].statusTH}}</span>
          </v-chip>
        </v-row>
        <v-card-text>
        <v-row align="center">
          <v-col cols="6">
            <v-card height="300">
              <div class="pa-3 text-center" style="background-color: #EFF4FD;">
                <span class="txt-head" style="color: #3776E9; font-size: 16px;">ข้อมูลการโอนสิทธิ์</span>
              </div>
              <v-row class="pa-5">
                <v-col cols="12">
                  <span class="ra-head-text">ชื่อสิทธิ์ย่อย: </span><span class="ra-head-text" style="font-weight: 550;">{{headerListData.authenName}}</span>
                </v-col>
                <v-col cols="12">
                  <span class="ra-head-text">สถานะ: </span><span class="ra-head-text" style="font-weight: 550;">{{headerListData.status === 'active' ? 'โอนสิทธิ์แล้ว' : 'ยังไม่โอนสิทธิ์'}}</span>
                  <!-- <span>สถานะ: {{ statusList.filter(e => e.status === status)[0].statusTH || '-' }}</span> -->
                </v-col>
                <v-col cols="12">
                  <span class="ra-head-text">รูปแบบการอนุมัติ: </span><span class="ra-head-text" style="font-weight: 550;">{{headerListData.conditions === 'all' ? 'อนุมัติทั้งหมด' : 'อนุมัติคนใดคนหนึ่ง' }}</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card height="300">
              <div class="pa-3 text-center" style="background-color: #EFF4FD;">
                <span class="txt-head" style="color: #3776E9; font-size: 16px;">ระยะเวลาการโอนสิทธิ์</span>
              </div>
              <v-row class="pa-5">
                <v-col cols="12">
                  <span class="ra-head-text">วันที่โอนสิทธิ์: </span><span class="ra-head-text" style="font-weight: 550;">{{initDate(headerListData.createAt)}}</span>
                </v-col>
                <v-col cols="12">
                  <span class="ra-head-text">ระยะเวลาการรับสิทธิ์: </span><span class="ra-head-text" style="font-weight: 550;">{{initDate(headerListData.startDate)}} - {{initDate(headerListData.endDate)}}</span>
                </v-col>
                <v-col cols="12">
                  <span class="ra-head-text">ใกล้หมดอายุ : </span><span class="ra-head-text" style="font-weight: 550;">{{headerListData.expire}} วัน</span>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
        <v-row justify="center" align="center" class="px-6">
          <v-col cols="6" class="pl-6">
            <!-- <p class="py-0 txt-head">Tag</p>
            <v-row class="px-1">
              <v-chip
                v-for="(item, i) in headerListData.tag" :key="i"
                :color="['approve','acknowledge', 'active'].includes('cancel')? '#ECF8EA': ['reject', 'expire'].includes('cancel')? '#FBE5E4': ['pending'].includes('cancel')? '#FEF5E9': ['cancel', 'inActive'].includes('cancel')? '#F5F5F5':'#ECF9FF'"
                :text-color="statusList.filter(e => e.status === 'cancel')[0].color"
              >
                <span>{{ item.name }}</span>
              </v-chip>
            </v-row> -->
            <v-row justify="start" align="start" class="pl-0" :style="$vuetify.breakpoint.name === 'xl' ? 'margin-right: -17%; margin-bottom: -7%;' : 'margin-right: 5%; margin-bottom: -7%;'">
              <v-col cols="8" xl="6" class="pt-0 pb-0">
                <!-- <span class="head-search-text">ค้นหา</span> -->
                <v-autocomplete
                  v-model="selectEmployee"
                  :items="selectEmployeeList"
                  outlined
                  dense
                  clearable
                  class="mt-2"
                  placeholder="ค้นหาได้จากชื่อ-รหัสพนักงาน"
                  no-data-text="ไม่พบข้อมูล"
                  @change="searchFilterData()"
                >
                <template v-slot:append>
                  <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
                </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 10px;">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  :nudge-top='-10'
                  max-width="328"
                  left
                  offset-y
                  origin='left'
                  tile
                  z-index="0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="head-search-button mt-2"
                      style="width: 96px; height: 38px;"
                      text
                      color="primary"
                      elevation="0"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon left>
                        mdi-filter-variant
                      </v-icon>
                      ตัวกรอง
                    </v-btn>
                  </template>
                  <v-card class="pa-3">
                    <v-row class="pt-3">
                      <v-col cols="12" class="pt-0 pb-0">
                        <span class="head-search-text">ตำแหน่ง</span>
                        <v-autocomplete
                          v-model="selectPosition"
                          :items="selectPositionList"
                          outlined
                          placeholder="ทั้งหมด"
                          no-data-text="ไม่พบข้อมูล"
                          class="mt-2"
                          dense
                          clearable
                          @click:clear="selectPosition='', searchFilterData(), page=1"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row class="pt-3">
                      <v-col cols="12" class="pt-0 pb-0">
                        <span class="head-search-text">ระดับตำแหน่ง</span>
                        <v-autocomplete
                          v-model="selectPositionLevel"
                          :items="selectPositionLevelList"
                          outlined
                          placeholder="ทั้งหมด"
                          no-data-text="ไม่พบข้อมูล"
                          class="mt-2"
                          dense
                          clearable
                          @click:clear="selectPositionLevel='', searchFilterData(), page=1"
                        >
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex">
                      <v-spacer/>
                      <v-btn
                        class="head-search-button mr-2"
                        outlined
                        color="primary"
                        style="width: 60px;"
                        elevation="0"
                        @click="resetFilterData()"
                      >ล้าง</v-btn>
                      <v-btn
                        class="btn-search-dep ml-2 mr-3"
                        color="primary"
                        style="width: 94px;"
                        dark
                        @click="searchFilterData()"
                      >ค้นหา</v-btn>
                    </v-row>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" class="text-right">
            <v-btn
              v-show="status !== 'inActive'"
              color="primary"
              outlined
              class="head-search-button mr-1 mt-8"
              @click="checkCancel('')"
            >
            ยกเลิกสิทธิ์
            </v-btn>
            <v-btn
              v-show="status !== 'inActive'"
              color="primary"
              class="head-search-button ml-1 mt-8 white--text text--lighten-4"
              elevation="0"
              @click="openDialogRenewal()"
            >
            <v-icon
                color="#3776E9 darken-2"
                class="pl-0 px-1"
                small
              >
                mdi-account-multiple
              </v-icon>
              <span>ต่ออายุสิทธิ์</span>
            </v-btn>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headersPrimaryRole"
              :items="employeeData"
              :items-per-page="5"
              class="border-table-employee text-no-wrap mt-1 mb-6 elevation-0"
              item-key="no"
              :expanded.sync="expanded"
              hide-default-footer
              disable-sort
            >
            <template v-slot:item="{ item, index }">
              <tr>
                <td>{{ index + 1  }}</td>
                <td>{{ item.nameTh }}</td>
                <td>{{ item.position }}</td>
                <td>{{ item.positionLevel }}</td>
                <td>{{ item.orgchartName }}</td>
                <td>{{ item.comapanyName }}</td>
                <td>
                  <v-chip
                    :color="['approve','acknowledge', 'active'].includes(item.status)? '#ECF8EA': ['reject', 'expire'].includes(item.status)? '#FBE5E4': ['pending'].includes(item.status)? '#FEF5E9': ['cancel', 'inActive'].includes(item.status)? '#F5F5F5':'#ECF9FF'"
                    :text-color="statusListTable.filter(e => e.status === item.status)[0].color"
                  >
                    <span>{{ statusListTable.filter(e => e.status === item.status)[0].statusTH || '-' }}</span>
                  </v-chip>
                </td>
                <td>
                  <v-row class="d-flex">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-show="item.status !== 'cancel'"
                          v-bind="attrs"
                          v-on="on"
                          rounded
                          dark
                          icon
                          small
                          class="ra-border-button mt-3 mb-3 ml-3"
                          @click="checkCancel(item.userId)"
                        >
                        <template v-slot>
                          <v-icon dark color="#D1392B" size="16px">mdi-close</v-icon>
                        </template>
                        </v-btn>
                      </template>
                      <span class="label-table-action">ยกเลิกสิทธิ์</span>
                    </v-tooltip>
                </v-row>
                </td>
              </tr>
            </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <v-dialog v-model="dialogConfirmDel" max-width="500px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการลบข้อมูล</span>
        <!-- <span v-else-if="titleDialog === 'temporaryer'" class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้รักษาการคนนี้</span> -->
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmDel = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="deleteBusiness()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmCancel" max-width="500px">
      <v-card height="180px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการยกเลิกสิทธิ์{{userIdList !== '' ? 'นี้' : 'ทั้งหมด'}}ใช่ไหม</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือไม่ว่าต้องการยกเลิกสิทธิ์</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="ra-button1" color="#1654C6" outlined @click="dialogConfirmCancel = false">ยกเลิก</v-btn>
          <v-btn class="ra-button1" color="#1654C6" dark @click="submitCancelRole()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        absolute
        text
        top
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
      <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </div>
    <dialogRoleRenewal/>
  </div>
</template>

<script>
import swal from 'sweetalert'
import moment from 'moment'
import { EventBus } from '@/EventBus'
import dialogRoleRenewal from '../../_managetransferrole/_dialog/dialogRoleRenewal'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import {
} from '@/API/API'
// const axios = require('axios')

export default {
  components: {
    OverlayLoading,
    dialogRoleRenewal
  },
  name: 'overview',
  data () {
    return {
      loading: false,
      expanded: [],
      snackbar: false,
      menu: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDeleteApprover: false,
      dialogApproverCompany: false,
      dialogConfirmCancel: false,
      dialogConfirmDel: false,
      reqBusinessId: '',
      comment: '',
      titleDialog: '',
      itemConfirmDelete: [],
      panel: [0, 1],
      chkDataEmp: 0,
      imageData: null,
      files: [],
      filesCertificate: [],
      imageUrl: '',
      status: 'cancel',
      type_files: ['pdf', 'png', 'jpg', 'jpeg', 'tiff', 'gif', 'rar', 'zip', '7z'],
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ],
      userDataStore: '',
      tokenUser: '',
      selectEmployee: '',
      selectEmployeeList: [],
      selectPosition: '',
      selectPositionList: [],
      selectPositionLevel: '',
      selectPositionLevelList: [],
      userIdList: '',
      userIdListTemporary: '',
      companyName: '',
      departmentName: '',
      orgChartDetail: '',
      approver: [
        // {
        //   no: 1,
        //   _id: '1212xx',
        //   employeeId: 'sittikorn0993',
        //   approverName: 'นายสมพงษ์ อิอิ',
        //   position: 'ตำแหน่ง xxxx',
        //   email: 'kookkai@one.th',
        //   userImg: 'https://picsum.photos/200',
        //   failed_image: true
        // }
      ],
      statusApproveRole: 'approve',
      headerListData: [],
      titleListData: [],
      temporaryer: [],
      employeeData: [],
      secRoleData: [],
      isSelecting: false,
      valid: true,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      headersTemporary: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'วันที่รักษาการ', value: '' },
        { text: 'เอกสาร', value: '' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      headersPrimaryRole: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'ผู้รับสิทธิ์', value: 'nameTh' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'ระดับตำแหน่ง', value: 'positionLevel' },
        { text: 'สายงานบังคับบัญชา', value: 'orgchartName' },
        { text: 'บริษัท', value: 'comapanyName' },
        { text: 'สถานะ', value: 'status' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      headersSecondRole: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'สิทธิ์ย่อย', value: 'primaryRole' },
        { text: 'สถานะการโอน', value: 'status' },
        { text: 'Tag', value: 'expireRole' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      statusList: [
        // { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'pending', statusTH: 'รออนุมัติ', color: '#E9A016' },
        { status: 'approve', statusTH: 'อนุมัติแล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ],
      statusListTable: [
        // { status: 'pending', statusTH: 'กำลังดำเนินการ', color: '#00B0FF' },
        { status: 'pending', statusTH: 'ยังไม่โอน', color: '#E9A016' },
        { status: 'approve', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ]
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
    EventBus.$on('closeDialogAuthen', this.searchFilterData)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
    EventBus.$off('closeDialogAuthen')
  },
  async created () {
    this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.propsitems = this.$route.params.id
    this.propsitemsOrgchart = this.$route.params.orgchartId
    this.reqBusinessId = this.$route.params.id
    if (!this.$store.state.token) {
      this.goBack()
    } else {
      this.getSelect(this.propsitems)
      await this.getRoleDetail(this.propsitems)
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    goBack () {
      // this.$router.push('/managetransferrole')
      this.$router.go(-1)
    },
    cancel () {
      this.$router.go(-1)
    },
    openDialogRenewal () {
      EventBus.$emit('dialogRoleRenewal', this.propsitems)
      // EventBus.$emit('openDialogAddAprover', true, item, action, index, type)
    },
    onImgError (i) {
      this.approver[i].failed_image = true
    },
    checkCancel (id) {
      this.userIdList = id
      this.dialogConfirmCancel = true
    },
    async resetFilterData () {
      this.selectPositionLevel = ''
      this.selectPosition = ''
      this.selectEmployee = ''
      await this.getRoleDetail(this.propsitems)
    },
    async searchFilterData () {
      await this.getRoleDetail(this.propsitems)
    },
    async getSelect (id) {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/authenTransferByIdSelect`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: this.propsitems
        }
      }).then((response) => {
        this.selectEmployeeList = response.data.result[0].nameTh
        this.selectPositionList = response.data.result[0].position
        this.selectPositionLevelList = response.data.result[0].positionLevel
      }).catch(e => {
        console.log(e)
      })
    },
    async getRoleDetail (id) {
      this.loading = true
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/authenTransferById`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: this.propsitems,
          search: this.selectEmployee,
          position: [this.selectPosition],
          positionLevel: [this.selectPositionLevel],
          limit: 15,
          page: 1
        }
      }).then((response) => {
        this.companyName = response.data.company.companyName
        this.orgChartDetail = response.data.orgchart.orgChartName
        this.departmentName = response.data.orgchart.orgChartName
        this.titleListData = response.data
        this.headerListData = response.data.result[0]
        this.status = response.data.result[0].status
        this.employeeData = response.data.result[0].transfer
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    },
    async submitCancelRole () {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/cancelAuthen`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          authenId: this.propsitems,
          userId: this.userIdList
        }
      }).then((response) => {
        if (response.data.success) {
          swal('สำเร็จ', 'ยกเลิกสิทธิ์สำเร็จ', 'success', {
            button: false,
            timer: 1000
          })
          this.dialogConfirmCancel = false
          this.dialogRoleRenewal = false
          this.getRoleDetail(this.propsitems)
          this.loading = false
        } else {
          swal('ผิดพลาด', 'ยกเลิกสิทธิ์ไม่สำเร็จ', 'error', {
            button: false,
            timer: 1500
          })
        }
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
      })
    },
    initDate (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    goHistory (id) {
      this.$router.push('/managetransferrole/updateHistory/' + this.propsitems + '/' + this.propsitemsOrgchart)
    },
    goCreateTransfer () {
      // this.$router.push('managetransferrole/createTransferrole')
      this.$router.push({
        name: 'manageTransferrolecreateTransferrole',
        params: {
          type: 'new',
          id: this.propsitems,
          orgchartId: this.propsitemsOrgchart
        }
      })
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-font-value {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.file-input {
  display: none;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
  display:none;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
tr.v-data-table__selected {
    background: #7d92f5 !important;
  }
</style>
